import { createAction, props } from "@ngrx/store";
import { Variable } from "../../models/formulas/variable";

export const findVariableCatalogAct = createAction('findVariableCatalogEffect', props <{ id: number }>());
export const loadVariableCatalogByIdAct = createAction('loadVariableCatalogByIdEffect', props<{ variable: Variable }>());

export const resetVariableCatalogAct = createAction('resetVariableCatalogEffect');

export const updateVariableCatalogAct = createAction('updateVariableCatalogEffect', props<{ variableUpdated: Variable }>());
export const updateSuccessVariableCatalogAct = createAction('updateSuccessVariableCatalogEffect', props<{ variableUpdated: Variable }>());

export const saveVariableCatalogAct = createAction('saveVariableCatalogEffect', props<{ variableNew: Variable }>());
export const saveSuccessVariableCatalogAct = createAction('saveSuccessVariableCatalogEffect', props<{ variableNew: Variable }>());

export const setViolationsVariableCatalogAct = createAction('setViolationsVariableCatalogEffect', props<{ variableForm: Variable, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
